module.exports = (__webpack_require__(4))(94);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/process/browser.js from dll-reference carbon.vendor
// module id = 3
// module chunks = 0